import React from "react";
import CampaignSearch from "./CampaignSearch";
import MoreFilter from "../ui/shared/MoreFilter";
import AddNewCampaign from "./AddNewCampaign";

// Define AccountCampaign type directly to avoid Database type conflicts
type AccountCampaign = {
  id: string
  account_id: string
  name: string
  assistant_id: string | null
  trigger_type: string
  trigger_keywords: string[] | null
  tags: string[] | null
  pipeline_id: string | null
  pipeline_stage_id: string | null
  is_active: boolean | null
  distribution_member_ids: string[] | null
  last_distribution_index: number | null
  created_at: string | null
  updated_at: string | null
}

type CampaignInsert = {
  name: string
  assistant_id: string | null
  trigger_type: string
  trigger_keywords: string[] | null
  tags: string[] | null
  pipeline_id: string | null
  pipeline_stage_id: string | null
  is_active: boolean | null
  distribution_member_ids: string[] | null
  last_distribution_index: number | null
}

interface FilterHeaderProps {
  onSearchChange?: (searchTerm: string) => void;
  createCampaign: (data: CampaignInsert) => Promise<boolean>;
}

const FilterHeader: React.FC<FilterHeaderProps> = ({ onSearchChange, createCampaign }) => {
  const handleCampaignSelect = (campaign: AccountCampaign) => {
    console.log('🎯 [FilterHeader] Campanha selecionada na busca:', campaign);
  };

  return (
    <div className="w-full mt-3 sm:mt-4 flex-wrap gap-3 flex justify-between items-center">
      <div className="flex items-center gap-2">
        {/* search ---------> */}
        <CampaignSearch 
          onCampaignSelect={handleCampaignSelect}
          onSearchChange={onSearchChange}
          placeholder="Pesquisar campanhas..."
          styles="w-[170px] sm:w-[220px] md:w-[270px] xl:w-[417px] min-h-[40px]"
        />
        {/* more filter ----------> */}
        <MoreFilter />
      </div>
      <AddNewCampaign createCampaign={createCampaign} />
    </div>
  );
};

export default FilterHeader;
